var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createModel } from './createModel';
/**
 * 创建 Redux Duck
 */
export function createDuck(_a) {
    var name = _a.name, initialState = _a.initialState, reducers = _a.reducers, actions = _a.actions;
    var model = createModel({ name: name, initialState: initialState, reducers: reducers });
    return __assign(__assign({}, actions), { name: model.name, reducer: model.reducer, useState: model.useState, selectState: model.selectState, 
        /**
         * 修改指定（一级）字段的状态值
         */
        change: model.actions.change, 
        /**
         * 修改指定字段的状态值
         *
         * *如果指定字段值是个对象，支持修改该对象部分字段的值，最多支持二级*
         */
        merge: model.actions.merge, 
        /**
         * 重置所有（或部分）字段的状态到初始值
         */
        reset: model.actions.reset });
}
